import { API } from '../../api'
import msg_srv from '../../api/msg_srv'
import { COOKIE } from '../../utils';

export default {
    namespaced: true,
    state: {
        showWebLogin: false,
        showWebLoginCode: false,
        showWebLoginWechatCode: false,
        showWebFamousPediaPop: false,
        curWebFamousPediaMenu: 0,
        curWebFamousPediaNew: false,
        showWebReport: false
    },
    getters: {},
    mutations: {},
    actions: {
        checkWebLogin({state}, params) {
            var userData = AppFate.$store.state.userData;
            state.showWebLogin = userData && userData.token ? false : true;
            state.showWebLoginCode = false;
            state.showWebLoginWechatCode = false;
            if(userData && userData.token) {
                AppFate.$store.state.userData = userData;
                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            }
        },
        getUserLogin({state}, params) {
            API.userLogin({
                f_type: params.type,
                login_id: params.tel,
                pwd: params.password
            }, function(data) {
                console.log('用户手机登录成功:::::::', data)
                state.showWebLogin = false;
                AppFate.$store.state.userData = data;
                COOKIE.setCookie('fatetoken', data.token, 5);
                window.sessionStorage.setItem("H5_Fate_UserInfo", JSON.stringify(data));
            }, function(data) {
                AppFate.$toast(msg_srv[data.status_code]);
            })
        },
        getLoginCode({state}, params) {
            API.sendLoginCode({
                f_type: params.type,
                mobile: params.tel
            }, function(data) {
                console.log('用户手机获取验证码成功::::::::', data)
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            })
        },
        getCodeLogin({state}, params) {
            API.getCodeLogin({
                code: params.code
            }, function(data) {
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb(data);
                }
            }, function(data) {
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb(data);
                }
            })
        },
        resetData({ state }) {
            state.showWebLogin = false;
            state.showWebLoginCode = false;
            state.showWebLoginWechatCode = false;
            state.showWebFamousPediaPop = false;
            state.curWebFamousPediaMenu = 0;
            state.showWebReport = false;
        }
    }
}